import { RootState } from 'store/rootTypes';

export const TrackingSelector = (state: RootState) => state.Tracking;
